export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOADING = 'USER_LOADING'
export const USER_ERROR = 'USER_ERROR'
export const USER_SET = 'USER_SET'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_ACTIVATE = 'USER_ACTIVATE'
